import React, {Component} from "react";
import DirectionBtn from "../../Buttons/DirectionBtn";
import * as Utils from "../../Utils";

class MainTopMenu extends Component {
    state = {
        date: Utils.getDate()
    }

    onPrev = () => {
        const {date} = this.state;
        date.setDate(date.getDate() - 1);
        this.setState({
            date: date
        })

        this.props.onDateChange(this.state.date);
    }

    onNext = () => {
        const {date} = this.state;
        date.setDate(date.getDate() + 1)
        this.setState({
            date: date
        })

        this.props.onDateChange(this.state.date);
    }

    setAlert = () => {
        if (!this.props.isDoneAllHomework) {
            return (<i className="alert">오늘 완료하지 못한 숙제가 있어요!</i>);
        }
    }

    render() {
        const years = this.state.date.getFullYear();
        const months = Utils.twoDigits(this.state.date.getMonth() + 1);
        const days = Utils.twoDigits(this.state.date.getDate());

        return (
            <div className="mainTopMenu">
                <strong className="title">오늘의 <span className="point">숙제</span></strong>
                <div className="dateWrapper">
                    <span className="today">
                        {years}년 {months}월 {days}일
                        {this.setAlert()}
                    </span>
                    <div className="btnWrapper">
                        <DirectionBtn btnName="prev" click={this.onPrev} size="small"/>
                        <DirectionBtn btnName="next" click={this.onNext} size="small"/>
                    </div>
                </div>
            </div>
        );
    }
}

MainTopMenu.defaultProps = {
    isDoneAllHomework: true,
    onDateChange: () => {
        console.warn('not register datechange function')
    }
}
export default MainTopMenu;



// WEBPACK FOOTER //
// ./src/components/Containers/MainTopMenu/index.js